<template>
    <div class="form">
        <!-- Categories options -->
        <div class="form__section">
            <div class="form__title">Kategorie</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.categories" 
                        :options="categoriesOptions"
                        :tracking-data-category="'Sights'"
                        :min-amount="1"
                        :output-array="true"
                        @change="fieldChangeHandler($event, 'categories')"
                    />
                </div>
            </div>
        </div>

        <!-- Other filter options -->
        <div class="form__section">
            <div class="form__title">Weitere Filteroptionen</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.other" 
                        :options="otherOptions"
                        @change="fieldChangeHandler($event, 'other')"
                    />
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'
import { getPoiConfig } from '@/utils/poi-data/poi-config'

export default {
    components: {
        SmrChoiceGroup,
    },
    mixins: [
        settingsTabBlueprint
    ],
    data() {
        return {
            data: {},
            categoriesOptions: getPoiConfig(this.optionsId).categories,
        }
    },
    computed: {
        ...mapGetters(['user']),
        otherOptions() {
            return [
                {value: 'favouritesOnly', label: 'Nur Favoriten', disabled: this.user ? false : true},
            ]
        }
    }
}
</script>
